import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getContentTypeConfig } from '../content/ContentTypeRegistry';

/**
 * Shows an icon based on resource type using a configurable registry.
 */
const ResourceTypeIcon = ({ type, sx = {} }) => {
  const { icon } = getContentTypeConfig(type);
  if (!icon || !icon.component) {
    return null;
  }
  const IconComponent = icon.component;
  const finalProps = { ...icon.props, fontSize: "small", sx };
  return <IconComponent {...finalProps} />;
};

ResourceTypeIcon.propTypes = {
  type: PropTypes.string,
  sx: PropTypes.object,
};

export default memo(ResourceTypeIcon);